import React, { ReactNode, useEffect } from "react"
import Icon from "components/elements/Icon"
import { useForm } from "react-hook-form"
import AutoSave from "./AutoSave"

type Props<T> = {
  onChange: (values: T) => void
  initialValues: any
  children: (control) => ReactNode
  onCancel?: (data: {}) => void
  selectedBlockId?: number
}

/**
 * Side-panel form for block attribute editors only (email/form builder blocks).
 * Resets only when the selected block changes. Use this instead of SidePanelForm
 * where initialValues do not need to be reapplied from outside (e.g. after a modal).
 * Avoiding initialValues in the effect deps prevents the scale slider from shaking.
 */
const SidePanelBlockAttributes = <T, >({
  onChange, onCancel, initialValues, children, selectedBlockId,
}: Props<T>) => {
  const { control, reset } = useForm({
    defaultValues: initialValues,
    mode: "onChange",
  })

  useEffect(() => {
    reset(initialValues)
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only reset on block switch
  }, [selectedBlockId])

  return (
    <form>
      <AutoSave control={control} onChange={onChange} />
      {onCancel && (
      <Icon
        icon="prev-arrow"
        onClick={onCancel}
        position="absolute"
        cursor="pointer"
        size={5}
        m={6}
      />
      )}
      {children({ control })}
    </form>
  )
}

export default SidePanelBlockAttributes
